<template>
  <h-inspection-page :title="h_i18n('ae9b9e9cea1400387a36eb46740cf07c')" @inspection-update="inspectionUpdate">
    <form-header :title="h_i18n('3a420f8818cebe6cfd1f7a0e804a2ef9')" title-width="5">
      <template #title>
        <h-p align="left" :title="h_i18n('4850ea222f13bd23bec1cdace19cb633')">003-S030120-F01</h-p>
        <h-p align="left" :title="h_i18n('0d53faf6a8f9e2b4dcb1c4a47b5931cf')">2018-8-30</h-p>
      </template>
      <template #body>
        <tr>
          <td class="haier-td haier-text-right" rowspan="3" colspan="4">{{ h_i18n('cf6ea1baa52799e6fd50bae579004503') }}</td>
          <td class="haier-td haier-text-right" colspan="2">{{ h_i18n('424063a13488ae654f8e77f2e799c88e') }}</td>
          <td class="haier-td haier-cell" colspan="3"></td>
          <td class="haier-td haier-text-right" colspan="2">{{ h_i18n('d9dc618e2d645a6717bb6b72837c1ba2') }}</td>
          <td class="haier-td haier-cell" colspan="3"></td>
          <td class="haier-td haier-text-right" colspan="2">{{ h_i18n('a790803c161d5f63232969c039e9698c') }}</td>
          <td class="haier-td haier-cell" colspan="3">{{ typeToValue(beforeData.supplyCode) }}</td>
          <td class="haier-td haier-text-right" colspan="2">{{ h_i18n('bef1852b76c31a26cf3b4e807d2adca2') }}</td>
           <td class="haier-td haier-cell" colspan="3">{{ typeToValue(beforeData.supplyName) }}</td>
        </tr>
        <tr>
          <td class="haier-td haier-text-right" colspan="2">{{ h_i18n('5bd1a4c34d0b6c92521962fb9b202add') }}</td>
          <td class="haier-td haier-cell" colspan="3"></td>
          <td class="haier-td haier-text-right" colspan="2">{{ h_i18n('94d550539c46eaa8ebffb27af4e552a9') }}</td>
          <td class="haier-td haier-cell" colspan="3"></td>
          <td class="haier-td haier-text-right" colspan="2">{{ h_i18n('0d399c2b57594c204b3539658922a6f6') }}</td>
          <td class="haier-td haier-cell" colspan="3">{{ typeToValue(beforeData.sybName) }}</td>
          <td class="haier-td haier-text-right" colspan="2">{{ h_i18n('3b8b8fe43ec8f6ce293e3296fc609f50') }}</td>
          <td class="haier-td haier-cell" colspan="3">{{ formDate(beforeData.sendDay) }}</td>
        </tr>
        <tr>
          <td class="haier-td haier-text-right" colspan="2">{{ h_i18n('d3d82d46881ddede6be88387fa1ecea0') }}</td>
          <td class="haier-td haier-cell" colspan="3">{{ typeToValue(beforeData.mtlName) }}</td>
          <td class="haier-td haier-text-right" colspan="2">{{ h_i18n('c360590c779e1138a42c9d8f35938e56') }}</td>
          <td class="haier-td haier-cell" colspan="3">{{ typeToValue(beforeData.mtlNo) }}</td>
          <td class="haier-td haier-text-right" colspan="2">{{ h_i18n('fc15ca6dd8d6225352885c6915429466') }}</td>
          <!-- <td class="haier-td haier-cell" colspan="3">{{ typeToValue(ppapAssess.sqeManagerName) }}</td> -->
          <td class="haier-td haier-cell" colspan="3">-</td>
          <td class="haier-td haier-text-right" colspan="2">{{ h_i18n('fbe26342011ea01a7a7a1f733a3a5a23') }}</td>
          <td class="haier-td haier-cell" colspan="3">{{ typeToValue(ppapAssess.modelManagerName) }}</td>
        </tr>

        <tr>
          <td class="haier-td haier-text-right the_td_style" colspan="4">{{ h_i18n('e66a355f3c6eee59b0fcc69addf26c7d') }}</td>
          <td class="the_td_style" colspan="20">
            <div class="the_td_content_style">
              <div class="the_td_content_title_style">{{ h_i18n('33a27ce63557fbc5d3fb6b163b03968f') }}</div>
              <el-radio-group v-model="mainData.isNewMaterial" disabled size="small">
                <el-radio label="Y">{{ h_i18n('0a60ac8f02ccd2cf723f927284877851') }}</el-radio>
                <el-radio label="N">{{ h_i18n('c9744f45e76d885ae1c74d4f4a934b2e') }}</el-radio>
              </el-radio-group>
            </div>

            <div class="the_td_content_style">
            <div class="the_td_content_title_style">{{ h_i18n('0035214fc61c2df770dfb691a9a8bebf') }}</div>
            <el-radio-group v-model="mainData.isDerivation" disabled size="small">
              <el-radio label="Y">{{ h_i18n('0a60ac8f02ccd2cf723f927284877851') }}</el-radio>
              <el-radio label="N">{{ h_i18n('c9744f45e76d885ae1c74d4f4a934b2e') }}</el-radio>
            </el-radio-group>
            <div class="the_td_content_row_style">
              <div style="display: flex;width: 400px;margin-left: 50px;">
                <div style="width:60px;">{{ h_i18n('7dc89074d77b06353c5da176d1ec1ec7') }}</div>
                <el-input style="transform: translateY(-8px);" disabled v-model="mainData.parentId" type="text"></el-input>
              </div>
            </div>
          </div>

          <div class="the_td_content_style">
            <div class="the_td_content_title_style">{{ h_i18n('3f82485214cdeac81f7e4c5f8986ceea') }}</div>
            <el-radio-group v-model="mainData.isMain" disabled size="small">
              <el-radio label="Y">{{ h_i18n('0a60ac8f02ccd2cf723f927284877851') }}</el-radio>
              <el-radio label="N">{{ h_i18n('c9744f45e76d885ae1c74d4f4a934b2e') }}</el-radio>
            </el-radio-group>
          </div>

          <div class="the_td_content_style">
            <div class="the_td_content_title_style">{{ h_i18n('b3a6da80f5f6b06d734194bf75424c69') }}</div>
            <el-radio-group v-model="mainData.isGea" disabled size="small">
              <el-radio label="Y">{{ h_i18n('0a60ac8f02ccd2cf723f927284877851') }}</el-radio>
              <el-radio label="N">{{ h_i18n('c9744f45e76d885ae1c74d4f4a934b2e') }}</el-radio>
            </el-radio-group>
          </div>

          <div class="the_td_content_style">
            <div class="the_td_content_title_style">{{ h_i18n('6139aff0565d406c904b81a514e856f5') }}</div>
            <el-radio-group v-model="mainData.isMarket" disabled size="small">
              <el-radio label="Y">{{ h_i18n('0a60ac8f02ccd2cf723f927284877851') }}</el-radio>
              <el-radio label="N">{{ h_i18n('c9744f45e76d885ae1c74d4f4a934b2e') }}</el-radio>
            </el-radio-group>
          </div>

          </td>
          <!-- <td class="haier-td haier-text-right" rowspan="4" colspan="4">适用性评估说明:</td>
          <td class="haier-td haier-text-right" colspan="2">是否为全新物料:</td>
          <td class="haier-td haier-cell" colspan="3">{{ mainDataType(mainData.isNewMaterial) }}</td>
          <td class="haier-td haier-text-right" colspan="2">是否为衍生号:</td>
          <td class="haier-td haier-cell" colspan="3">{{ mainDataType(mainData.isDerivation) }}</td>
          <td class="haier-td haier-text-right" colspan="2">母本号:</td>
          <td class="haier-td haier-cell" colspan="8">{{ mainDataType(mainData.parentId) }}</td>
        </tr>
        <tr>
          <td class="haier-td haier-text-right" colspan="5">是否为主关件:</td>
          <td class="haier-td haier-cell" colspan="15">{{ mainDataType(mainData.isMain) }}</td>
        </tr>
        <tr>
          <td class="haier-td haier-text-right" colspan="5">是否为GEA品牌等特殊项目及模块:</td>
          <td class="haier-td haier-cell" colspan="15">{{ mainDataType(mainData.isGea) }}</td>
        </tr>
        <tr>
          <td class="haier-td haier-text-right" colspan="5">是否为市场损失大，产线评估需要重点控制的模块:</td>
          <td class="haier-td haier-cell" colspan="15">{{ mainDataType(mainData.isMarket) }}</td> -->
        </tr>

        <tr>
          <td class="haier-td haier-text-right" rowspan="1" colspan="4">{{ h_i18n('c3b1af42cd0c4df2d8f7f906e49bdbeb') }}</td>
          <td class="haier-td haier-cell" colspan="20">{{ typeToValue(mainData.isNeedPpap === "Y" ? h_i18n('b4a02eea14f47a8b387883f759530577') : mainData.isNeedPpap === "N" ? h_i18n('8f29ade52dff8a62013548a6c4f4859d') : "") }}</td>
        </tr>
        <tr>
          <td class="haier-td haier-text-right" rowspan="1" colspan="4">{{ h_i18n('4453839356561ed8351421d373d577b4') }}</td>
          <td class="haier-td haier-text-right" colspan="2">{{ h_i18n('e41af60f5a6e586d9c365f228824f3bb') }}</td>
          <!-- <td class="haier-td haier-cell" colspan="3">{{ typeToValue(ppapAssess.sqeManagerName) }}</td> -->
          <td class="haier-td haier-cell" colspan="3"> - </td>
          <td class="haier-td haier-text-right" colspan="2">{{ h_i18n('7501567af9e3ab38d02ed6e2420a7225') }}</td>
          <td class="haier-td haier-cell" colspan="3">{{ formDate(ppapAssess.sqeManagerAuditDate, 6) }}</td>
          <td class="haier-td haier-text-right" colspan="2">{{ h_i18n('349c6e7f74e0470e70f06d2761ea80ee') }}</td>
          <td class="haier-td haier-cell" colspan="8">{{ typeToValue(ppapAssess.sqeManagerAuditText) }}</td>
        </tr>
<!--        <tr>-->
<!--          <td class="haier-td haier-text-right" rowspan="1" colspan="4">SQE接口人审核:</td>-->
<!--          <td class="haier-td haier-text-right" colspan="2">签字:</td>-->
<!--          <td class="haier-td haier-cell" colspan="3">{{ typeToValue(ppapAssess.sqePortName) }}</td>-->
<!--          <td class="haier-td haier-text-right" colspan="2">日期:</td>-->
<!--          <td class="haier-td haier-cell" colspan="3">{{ formDate(ppapAssess.sqePortAuditDate, 6) }}</td>-->
<!--          <td class="haier-td haier-text-right" colspan="2">审核意见:</td>-->
<!--          <td class="haier-td haier-cell" colspan="8">{{ typeToValue(ppapAssess.sqePortAuditText) }}</td>-->
<!--        </tr>-->
      </template>
      <div style="height: 100px">
        <h-button-group align="center">
          <h-button type="default" @click="$router.back()">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</h-button>
        </h-button-group>
      </div>

    </form-header>

  </h-inspection-page>
</template>




<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

export default {
  name: "PPAPApplicabilityEvaluationDetail",
  data() {
    return {
      beforeData: {},
      mainData: {},
      ppapAssess: {}
    }
  },
  mounted() {
    this.searchValue()
  },
  methods: {
    h_i18n,
    inspectionUpdate() {
      this.postThisPageHeight()
    },
    typeToValue(value) {
      return value ? value : "-"
    },
    mainDataType(value) {
      return value ? value === "Y" ? "是" : "否" : "-"
    },
    formDate(val, q = 6) {
      return val ? this.time(val, q) : "-"
    },
    //assessId
    searchValue() {
      this.$http({
        method: "GET",
        url: "/base/patternPlan/selectPpapAssessDetail?assessId=" + this.$route.query.assessId,
      }).then(res => {
        if (res.data.code === "200") {
          this.beforeData = res.data.data.patternPlan
          this.mainData = res.data.data
          this.ppapAssess = res.data.data.ppapAssess
          try {
            delete this.mainData.patternPlan
            delete this.mainData.ppapAssess
          } catch (e) {
            console.log(e)
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.h-hwork-form-header {
  padding: 0;
}

:deep(.haier-table-header--right) {
  position: unset !important;
}

.haier-td {
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  text-align: left;
  padding: 4px 10px;
  font-size: 14px;
  height: 35px;
  color: #666;
}

.haier-cell {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.haier-text-right {
  text-align: right;
}

.haier-cell:hover {
  white-space: normal;
  word-break: break-all;
}
.the_td_style {
  font-size: 14px;
  color: #666;
  height: 300px;
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  padding-left: 20px;
  .the_td_content_style{
    height: 57px;
    // padding: 10px 0 8px 0;
    .the_td_content_title_style{
      padding: 3px 0;
    }
  }
  .the_td_content_row_style{
    display: inline-block;
  }
}
</style>